import RaiffeisenBank from './RaiffeisenBank';

export default RaiffeisenBank;
